import { useEffect, useState } from 'react';
import InitialData from '../InitialData';

let cachedPrices = null;
let inFlight = null;

const getFallbackPrices = () => {
  return InitialData.flatMap((apartment) =>
    (apartment.price || []).map((price) => ({
      apartmentId: apartment.id,
      apartmentName: apartment.name,
      apartmentLongName: apartment.longName,
      dates: price.dates,
      minStay: price.minStay,
      rate: price.rate,
    })),
  );
};

const fetchPrices = async () => {
  const response = await fetch('/.netlify/functions/get-prices');
  if (!response.ok) {
    return getFallbackPrices();
  }
  const prices = await response.json();
  return Array.isArray(prices) && prices.length ? prices : getFallbackPrices();
};

const usePricePeriods = () => {
  const [prices, setPrices] = useState(cachedPrices);
  const [loading, setLoading] = useState(!cachedPrices);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    if (cachedPrices) {
      return undefined;
    }

    if (!inFlight) {
      inFlight = fetchPrices();
    }

    inFlight
      .then((data) => {
        cachedPrices = data;
        if (isMounted) {
          setPrices(data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (isMounted) {
          const fallbackPrices = getFallbackPrices();
          cachedPrices = fallbackPrices;
          setPrices(fallbackPrices);
          setError(null);
          setLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { prices, loading, error };
};

export default usePricePeriods;
